/**
 * custom-countdown-timer.js
 * Standalone custom element — no theme module dependencies.
 * Works with the custom-countdown-timer.liquid snippet.
 */
(function () {
  'use strict';

  const pad = n => String(Math.max(0, n)).padStart(2, '0');

  class CustomCountdownTimer extends HTMLElement {
    connectedCallback () {
      const endStr = this.dataset.end;
      if (!endStr) return;

      this._end      = new Date(endStr).getTime();
      this._hasSecs  = this.hasAttribute('data-seconds');

      if (isNaN(this._end)) {
        console.warn('[custom-countdown-timer] Invalid date:', endStr);
        return;
      }

      /* Cache unit elements */
      this._units = {
        days:    this.querySelector('[data-days]'),
        hours:   this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this._hasSecs ? this.querySelector('[data-seconds]') : null,
      };

      this._tick();
      this._interval = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback () {
      clearInterval(this._interval);
    }

    _tick () {
      const diff = this._end - Date.now();

      if (diff <= 0) {
        clearInterval(this._interval);
        this._set('days',    0);
        this._set('hours',   0);
        this._set('minutes', 0);
        if (this._hasSecs) this._set('seconds', 0);
        return;
      }

      /* Reveal on first valid tick */
      this.removeAttribute('hidden');

      this._set('days',    Math.floor(diff / 86400000));
      this._set('hours',   Math.floor(diff % 86400000 / 3600000));
      this._set('minutes', Math.floor(diff % 3600000  / 60000));
      if (this._hasSecs) {
        this._set('seconds', Math.floor(diff % 60000 / 1000));
      }
    }

    /**
     * Update one unit with animation.
     * @param {string} unit  - 'days'|'hours'|'minutes'|'seconds'
     * @param {number} value - new numeric value
     */
    _set (unit, value) {
      const cur = this._units[unit];
      if (!cur) return;

      const next      = cur.nextElementSibling; // .cct__digit--nxt
      const container = cur.closest('.cct__number');
      const padded    = pad(value);

      if (cur.textContent === padded) return; /* no change */

      if (!next || !container) {
        cur.textContent = padded;
        return;
      }

      /* Set the incoming value on the hidden "next" digit */
      next.textContent = padded;

      /* Trigger CSS animation by toggling the class */
      container.classList.remove('cct--tick');
      /* Force reflow so removing → re-adding the class re-triggers animation */
      void container.offsetWidth;
      container.classList.add('cct--tick');

      /* After animation: swap text on cur, remove tick class */
      const DURATION = 550; /* must be ≥ longest animation duration in CSS */
      setTimeout(() => {
        cur.textContent  = padded;
        next.textContent = padded;
        container.classList.remove('cct--tick');
      }, DURATION);
    }
  }

  if (!customElements.get('custom-countdown-timer')) {
    customElements.define('custom-countdown-timer', CustomCountdownTimer);
  }
})();